const resources = {
    relatedContentLabel: 'Related Content',
    exploreMoreLabel: 'Explore More'
};

export default function getResource(label) {
    return resources[label];
}
